export default function DefaultImageUser({ color = 'primary' }) {
  return (
    <span
      className={`w-full h-full  flex items-center justify-center bg-secondary text-primary`}
      style={{
        backgroundColor: color == 'primary' ? 'secondary' : color + '2a',
        color,
      }}
    >
      <svg
        className={`w-1/2 h-1/2`}
        style={{ color: color }}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle stroke="currentColor" cx="12" cy="7" r="4" strokeWidth="2" strokeLinecap="round" />
        <path
          stroke="currentColor"
          d="M5.33788 18.3206C5.99897 15.5269 8.77173 14 11.6426 14H12.3574C15.2283 14 18.001 15.5269 18.6621 18.3206C18.79 18.8611 18.8917 19.4268 18.9489 20.0016C19.0036 20.5512 18.5523 21 18 21H6C5.44772 21 4.99642 20.5512 5.0511 20.0016C5.1083 19.4268 5.20997 18.8611 5.33788 18.3206Z"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </span>
  );
}
